var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","align-start":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('Graph',{attrs:{"fullDate":_vm.fullDate}})],1),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('SideCard',{on:{"activeBlock":(val) => _vm.blockId = val}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }